import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Button, Container, Card } from "react-bootstrap";
import { getAgent, deleteAgent } from "../../store/slices/agent";
import DeleteModal from "./deletepopup";
import { useDispatch, useSelector } from "react-redux";
import { FaEdit, FaTrash, FaSearch } from "react-icons/fa";


export default function Agents() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { agentList = [], loading } = useSelector((state) => state.agent);

  const [showDelete, setShowDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [deleteStatus, setDeleteStatus] = useState("confirm");

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [search, setSearch] = useState("");
  const [service, setService] = useState("");

  useEffect(() => {
    const params = {
      page: currentPage,
      limit: 10,
    };

    if (search) params.search = search;
    if (service) params.service = service;

    dispatch(getAgent(params));
  }, [dispatch, currentPage, search, service]);

  const handleConfirmDelete = async () => {
    try {
      setDeleteStatus("loading");

      await dispatch(deleteAgent(selectedId)).unwrap();

      setDeleteStatus("success");

      setTimeout(() => {
        setShowDelete(false);
        setDeleteStatus("confirm");
      }, 1500);
    } catch (error) {
      setDeleteStatus("confirm");
    }
  };

  const totalPages = Math.ceil(agentList.total / itemsPerPage);

  const currentAgents = agentList?.agents || [];

  const changePage = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
    }
  };

  return (
    <>
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span
            className="breadcrumb-link inactive"
            onClick={() => navigate("/admin/agent")}
          >
            Agents
          </span>
        </div>

        <button
          className="add-outlet-btn"
          onClick={() => navigate("/admin/addagent")}
        >
          + Add New
        </button>
      </div>
      <Container fluid className="mb-5">
        <Card className="table-border">
          <Card.Body>
            <div className="guests-table-wrapper common-table-wrapper py-2">
              <div className="d-flex gap-2 mb-3">
                <div
                  className="position-relative ms-2"
                  style={{
                    maxWidth: "250px",
                    width: "100%",
                  }}
                >
                  <FaSearch
                    className="position-absolute"
                    style={{
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#999",
                      fontSize: "12px",
                      zIndex: 2,
                      pointerEvents: "none",
                    }}
                  />
                  <input
                    type="text"
                    className="form-control vendor-search-input"
                    placeholder="Search name, email, mobile"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    style={{ maxWidth: "250px" }}
                  />

                </div>

                <button
                  className="cancel-btn"
                  onClick={() => {
                    setSearch("");
                    setService("");
                  }}
                >
                  Reset
                </button>
              </div>

              <table className="table guests-table common-table align-middle">
                <thead>
                  <tr>
                    <th className="text-center">#</th>
                    <th className="text-center">Name</th>

                    <th className="text-center">Mobile</th>
                    <th className="text-center">Email</th>
                    <th className="text-center">Type</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>

                <tbody>
                  {loading
                    ? [...Array(6)].map((_, index) => (
                      <tr key={index}>
                        <td className="text-center">
                          <div className="skeleton skeleton-text small"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-image"></div>
                        </td>

                        <td className="text-center">
                          <div className="skeleton skeleton-text"></div>
                        </td>

                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-2">
                            <div className="skeleton skeleton-btn"></div>
                            <div className="skeleton skeleton-btn"></div>
                          </div>
                        </td>
                      </tr>
                    ))
                    : currentAgents.map((agent, index) => (
                      <tr key={agent._id}>
                        <td className="text-center">
                          {(currentPage - 1) * itemsPerPage + index + 1}
                        </td>

                        <td className="text-center">{agent.name}</td>

                        <td className="text-center">{agent.mobileNumber}</td>

                        <td className="text-center">{agent.email}</td>
                        <td className="text-center">{agent.services}</td>

                        <td className="text-center">
                          <div className="action-btn-group d-flex justify-content-center gap-2">
                            <button
                              onClick={() =>
                                navigate(`/admin/editagent/${agent._id}`)
                              }
                              className="action-btn edit-btn"
                            >
                              <FaEdit size={14} />
                            </button>

                            {/* Delete */}
                            <button
                              className="action-btn delete-btn"
                              onClick={() => {
                                setSelectedId(agent._id);
                                setShowDelete(true);
                              }}
                            >
                              <FaTrash size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            {!loading && totalPages > 1 && (
              <div className="d-flex justify-content-center align-items-center gap-2 mt-4 flex-wrap">

                <Button
                  variant="light"
                  disabled={currentPage === 1}
                  onClick={() =>
                    setCurrentPage(currentPage - 1)
                  }
                >
                  ‹
                </Button>


                {Array.from(
                  { length: totalPages },
                  (_, i) => i + 1
                )
                  .filter((page) => {

                    return (
                      page === 1 ||
                      page === totalPages ||
                      Math.abs(page - currentPage) <= 1
                    );

                  })
                  .map((page, index, arr) => {

                    const prevPage = arr[index - 1];

                    return (
                      <div
                        key={page}
                        className="d-flex align-items-center gap-2"
                      >

                        {/* DOTS */}
                        {
                          prevPage &&
                          page - prevPage > 1 && (
                            <span>...</span>
                          )
                        }

                        <Button
                          variant={
                            currentPage === page
                              ? "dark"
                              : "light"
                          }
                          onClick={() =>
                            setCurrentPage(page)
                          }
                        >
                          {page}
                        </Button>

                      </div>
                    );
                  })}

                {/* NEXT */}

                <Button
                  variant="light"
                  disabled={
                    currentPage === totalPages
                  }
                  onClick={() =>
                    setCurrentPage(currentPage + 1)
                  }
                >
                  ›
                </Button>

              </div>
            )}
          </Card.Body>
        </Card>
      </Container>
      <DeleteModal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        onConfirm={handleConfirmDelete}
        status={deleteStatus}
      />
    </>
  );
}
